import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { BroadcastListContent } from 'modules/broadcastManager/broadcastList';
import ContentBasePage from 'modules/content/components/ContentBasePage';

export default class BroadcastManager extends PureComponent {
  render() {
    return (
      <ContentBasePage className="content__grid">
        <ContentBasePage.Header
          hideBackHandler
          title="broadcast.broadcast_manager"
        >
          <Link to={ROUTES.BROADCAST.NEW}>
            <button className="hot-button hot-button--primary hot-button--lg">
              <Icon prefix="fal" iconName="plus" className="_mr-2" />
              <I18n label="broadcast.add_broadcast" />
            </button>
          </Link>
        </ContentBasePage.Header>
        <BroadcastListContent />
      </ContentBasePage>
    );
  }
}
